import {
  Avatar,
  AvatarProps,
  Box,
  Divider,
  MenuItem,
  // Stack,
  // styled,
  Typography,
} from '@mui/material';
import { FunctionComponent, ReactNode } from 'react';
// import { NavLink } from 'react-router-dom';
// import { routes } from '@routes';
import { Dropdown } from '@components/ui/dropdown';
import { useAuth } from '@context/auth';

export type AccountDropdownProps = {
  subtitle: ReactNode;
  title: ReactNode;
  avatarProps?: AvatarProps;
  avatarContent?: React.ReactNode;
};

export const AccountDropdown: FunctionComponent<AccountDropdownProps> = (
  props,
) => {
  const { avatarContent, avatarProps, subtitle, title } = props;
  const { logout } = useAuth();

  return (
    <Dropdown
      actionComponent={<Avatar {...avatarProps}>{avatarContent}</Avatar>}
    >
      <Box sx={{ my: 1.5, px: 2.5 }}>
        <Typography variant="subtitle2" noWrap>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {subtitle}
        </Typography>
      </Box>
      <Divider sx={{ borderStyle: 'dashed' }} />
      {/* <Stack sx={{ p: 1 }}>
        <StyledNavLink to={routes.profile}>
          <MenuItem>Profile </MenuItem>
        </StyledNavLink>
        <StyledNavLink to={routes.settings}>
          <MenuItem>Settings </MenuItem>
        </StyledNavLink>
      </Stack>
      <Divider sx={{ borderStyle: 'dashed' }} /> */}
      <MenuItem sx={{ m: 1 }} onClick={logout}>
        Logout
      </MenuItem>
    </Dropdown>
  );
};
